import React, { useEffect } from "react" 
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addmedproviders, updateMedProvider } from "service/api";
import DatatableTables from "./Medprovider";



const defaultValue = {
  med_provider: ""
}

const AddMedicalAid = () => {
  const [formData, setData] = useState(defaultValue);
  const [selectedId, setSelectedId] = useState(null);
  const [errors, setErrors] = useState({});
  const [refreshTable, setRefreshTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onValueChange = (e) => {
    setData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

const validate = () => {
    let tempErrors = {};
    if (!formData.med_provider.trim()) {
      tempErrors.med_provider = "Medical Aid Name is required";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

const handleAddMedicalAid = async (e) => {
    e.preventDefault()
    if (!validate()) return

    setLoading(true) // Start loading

    try {
      if (selectedId) {
        await updateMedProvider(selectedId, formData)
        toast.success("Medical Aid updated successfully.")
      } else {
        await addmedproviders(formData)
        toast.success("Medical Aid added successfully.")
      }

      setData(defaultValue)
      setSelectedId(null)
      setRefreshTable((prev) => !prev)
    } catch (err) {
      console.error("Error saving medical aid:", err)
      toast.error("Failed to save Medical Aid.")
    } finally {
      setLoading(false) // Stop loading
    }
  }

  const handleEdit = (data) => {
    setData({ med_provider: data.med_provider });
    setSelectedId(data._id);
  };

  const handleCancel = () => {
    setData(defaultValue);
    setSelectedId(null);
  };

    
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title">
              {selectedId ? "Edit Medical Aid" : "Add Medical Aid"}
            </h4>
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Medical Aid Name<span style={{ color: "red" }}>*</span>
</Label>
                        <Input
                          type="text"
                          className={`form-control ${errors.med_provider ? "is-invalid" : ""}`}
                          name="med_provider"
                          Placeholder="Enter Medical Aid Name"
                          value={formData.med_provider}
                          onChange={e => onValueChange(e)}
                        />
                        {errors.med_provider && (
                          <div className="invalid-feedback">{errors.med_provider}</div>
                        )}
                      </div>
                    </Col>
                  </Row>
                 <div>
                    <Button
                      color="primary"
                      className="w-md mx-2"
                      onClick={handleAddMedicalAid}
                      disabled={loading}
                    >
                      {loading
                        ? "Saving..."
                        : selectedId
                        ? "Update"
                        : "Save"}
                    </Button>

                    {selectedId && !loading && (
                      <Button
                        color="secondary"
                        className="w-md"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    )}
                  </div>
                  
                </Form>
              </CardBody>
            </Card>
          </Row>

         
        <DatatableTables refresh={refreshTable} onEdit={handleEdit} />

          
        </Container>
      </div>
    </React.Fragment>
  )
}

export default  AddMedicalAid;
